import { AlertCircle, Inbox, Loader2 } from 'lucide-react';

/** Inline spinner shown while a report is being fetched. */
export const ReportLoading = ({ label = 'در حال بارگذاری گزارش...' }) => (
    <div className="report-state">
        <Loader2 size={20} className="report-state-spin" />
        <span>{label}</span>
    </div>
);

/** Inline error that never exposes backend or transport details. */
export const ReportError = ({ label = 'خطا در بارگذاری گزارش' }) => {
    return (
        <div className="report-state report-state-error">
            <AlertCircle size={20} />
            <span>{label}</span>
        </div>
    );
};

/** Inline empty state. */
export const ReportEmpty = ({ label = 'داده‌ای برای این بازه وجود ندارد' }) => (
    <div className="report-state">
        <Inbox size={20} />
        <span>{label}</span>
    </div>
);

/**
 * Card wrapper for a single chart or table.
 *
 * Owns the four states every report can be in (loading, error, empty, ready)
 * so pages never repeat that branching, and pins a height so Recharts has a
 * measurable box to draw into.
 */
export default function ChartCard({
    title,
    subtitle,
    actions,
    height = 320,
    isLoading = false,
    isError = false,
    isEmpty = false,
    emptyLabel,
    className = '',
    bodyClassName = '',
    children,
}) {
    const showState = isLoading || isError || isEmpty;

    return (
        <section className={`card report-card ${className}`.trim()}>
            {(title || actions) && (
                <header className="report-card-head">
                    <div>
                        {title && <h3 className="report-card-title">{title}</h3>}
                        {subtitle && <p className="report-card-subtitle">{subtitle}</p>}
                    </div>
                    {actions && <div className="report-card-actions">{actions}</div>}
                </header>
            )}

            <div
                className={`report-card-body ${bodyClassName}`.trim()}
                style={showState ? undefined : { minHeight: height }}
            >
                {isLoading ? (
                    <ReportLoading />
                ) : isError ? (
                    <ReportError />
                ) : isEmpty ? (
                    <ReportEmpty label={emptyLabel} />
                ) : (
                    children
                )}
            </div>
        </section>
    );
}
